import { can, canAny } from './access.js';
import { isTenantFeatureEnabled } from '@/config/tenantFeatures.js';

export const CUSTOMER_DEBT_PATH = '/ctasctes/cuenta-corriente-clientes/deuda-de-clientes';

// Match the existing PDF endpoint: a view permission AND PDF generation.
export function canAccessCustomerDebt(user, tenant) {
  return isTenantFeatureEnabled(tenant, { to: CUSTOMER_DEBT_PATH, featureCode: 'CTAS_CTES' })
    && can(user, 'CUENTA_CORRIENTE_GENERAR_PDF')
    && canAny(user, ['CUENTA_CORRIENTE_VER', 'CLIENTES_VER', 'FACTURACION_VER', 'COBRANZAS_VER']);
}
